let initHeroSlider = () => {
  let heroSlider = document.querySelector('.ndow-hero--slider');
  if (heroSlider) {
    let swiper = new Swiper('.ndow-hero--slider .swiper-container', {
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.ndow-hero--slider .swiper-pagination',
        clickable: true,
      },
      // navigation: {
      //   nextEl: '.ndow-hero--slider .swiper-button-next',
      //   prevEl: '.ndow-hero--slider .swiper-button-prev',
      // },
    });
  }
}

document.addEventListener('DOMContentLoaded', initHeroSlider);